export const ENV = (import.meta.env.VITE_ENV || 'production').trim();
export const IS_IN_MAINTENANCE = (import.meta.env.VITE_IS_IN_MAINTENANCE || '').trim();

export const API_ENDPOINT = (import.meta.env.VITE_API_ENDPOINT || '').trim();

export const CDN_ENDPOINT = (import.meta.env.VITE_CDN_ENDPOINT || '').trim();
export const CDN_URL = (import.meta.env.VITE_CDN_URL || '').trim();
export const SUN_URL = (import.meta.env.VITE_SUN_URL || '').trim();
export const GOOGLE_MAPS_PLACE_APIKEY = (import.meta.env.VITE_GOOGLE_MAPS_PLACE_APIKEY || '').trim();
export const COOKIE_DOMAIN = (import.meta.env.VITE_COOKIE_DOMAIN || '').trim();
export const REGISTRY_URL = (import.meta.env.VITE_REGISTRY_URL || '').trim();

export const SENTRY_KEY = (import.meta.env.VITE_SENTRY_KEY || '').trim();

export const TOAST_DEFAULT_TIMEOUT = 3000;
export const TOAST_ERROR_TIMEOUT = 5000;

export const EDUZZ_REGISTRY_VALID_KEY = 'eduzz_registry_valid';
export const EDUZZ_REGISTRY_MODAL_VIEWED_KEY = 'eduzz_registry_modal_viewed';

export const IS_DEVELOPMENT = import.meta.env.VITE_ENV === 'development' || import.meta.env.VITE_ENV === 'homolog';
export const IS_PROD = ENV === 'production';
export const BLINKET_ID = import.meta.env.VITE_BLINKET_ID;

export const REACT_TOKEN = (import.meta.env.VITE_TOKEN || '').trim();
export const REACT_SECRET = (import.meta.env.VITE_SECRET || '').trim();
export const BLINKET_APP_URL = (import.meta.env.VITE_BLINKET_APP_URL || '').trim();
export const BLINKET_TICKETS_APP_URL = (import.meta.env.VITE_BLINKET_TICKETS_APP_URL || '').trim();
export const BLINKET_EVENT_URL = (import.meta.env.VITE_BLINKET_EVENT_URL || '').trim();

export const ACCOUNT_PARTNER = 'b1b17e0c-3438-4316-bb6d-283c9ff622c1';
export const ACCOUNT_ENV =
  import.meta.env.VITE_ENV === 'production' ? {} : { env: ENV === 'development' ? 'dev' : 'qa' };

export const ORBITA_URL = (import.meta.env.VITE_ORBITA_URL || '').trim();
export const VERTICAL_URL = (import.meta.env.VITE_VERTICAL_URL || '').trim();

export const WEBHOOK_URL = (import.meta.env.VITE_WEBHOOK_URL || '').trim();

export const WEBCHAT_PROXY_URL = import.meta.env.VITE_WEBCHAT_PROXY_URL || '';
export const WEBCHAT_CLIENT_ID = import.meta.env.VITE_WEBCHAT_CLIENT_ID || '';

export const GOOGLE_ANALYTICS_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID ?? '';
export const CLARITY_ID = import.meta.env.VITE_CLARITY_ID ?? '';

export const ORBIT_PAGES_URL = import.meta.env.VITE_ORBIT_PAGES_URL ?? '';
export const DEPOIMENTUS_URL = import.meta.env.VITE_DEPOIMENTUS_URL ?? '';
